import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "title" }

import { computed, onMounted, ref } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import {
  methodGroupShow,
  methodGroupUpdate,
} from "@/common/api/rest/method/method-group";

import type { MethodGroupPayloadType } from "@/common/types/method/method-group";

import { RegisterTheme } from "@/common/themes";
import { iconMenu, svgIcon } from "@/common/components";

import MethodGroupForm from "@/components/forms/method-group.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const methodPayload = ref<MethodGroupPayloadType | null>(null);

const isLoading = ref(false);
const fieldLoading = ref(false);

const accountId = computed(() => String(route.params.id));
const groupId = computed(() => String(route.params.group));

const menuTabs = computed(() => [
  {
    key: "edit",
    icon: "home-line",
    label: t("common.labels.group"),
  },
  {
    key: "field",
    icon: "field",
    label: t("common.labels.fields"),
  },
  {
    key: "method",
    icon: "method",
    label: t("common.labels.methods"),
  },
  {
    key: "question",
    icon: "form",
    label: t("common.labels.questions"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/method`);
}

function goToTab(tab: string) {
  router.push(`/${accountId.value}/register/method/${groupId.value}/${tab}`);
}

// CATEGORY
function fetchCategory() {
  isLoading.value = true;
  fieldLoading.value = true;

  methodGroupShow(accountId.value, groupId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        methodPayload.value = {
          status: data.status,
          name: data.name,
          description: data.description,
        };
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      isLoading.value = false;
      fieldLoading.value = false;
    });
}

function updateCategory(payload: MethodGroupPayloadType) {
  methodGroupUpdate(accountId.value, groupId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCategory();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const debounceCategory = debounce(updateCategory, 1000);

onMounted(() => {
  if (groupId.value) {
    fetchCategory();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RegisterTheme), { "tab-active": "method" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "method",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.method") })), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-back btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "close",
            size: "1.25rem"
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(iconMenu), {
        tabs: menuTabs.value,
        active: "edit",
        onSelected: _cache[2] || (_cache[2] = ($event: any) => (goToTab($event)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("common.labels.method_group")), 1),
          _createVNode(MethodGroupForm, {
            width: "100%",
            data: methodPayload.value,
            onUpdateData: _cache[1] || (_cache[1] = ($event: any) => (_unref(debounceCategory)($event)))
          }, null, 8, ["data"])
        ]),
        _: 1
      }, 8, ["tabs"])
    ]),
    _: 1
  }))
}
}

})